import { render, staticRenderFns } from "./MergerAcquisitionForm.vue?vue&type=template&id=2e83a558&"
import script from "./MergerAcquisitionForm.vue?vue&type=script&lang=ts&"
export * from "./MergerAcquisitionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports